import Divider from "@mui/material/Divider/Divider";
import Grid from "@mui/material/Grid/Grid";
import Typography from "@mui/material/Typography/Typography";

import { AutocompleteMultipleComponent } from "../../../../../components";

const CPRSectionComponent = ({ control, formCPROptions, isLoading }) => {
  return (
    <div>
      <Typography
        style={{
          fontWeight: "600",
          fontSize: "1.75vh",
          color: "#5C5C5C",
        }}
      >
        CPR - POR REVENDEDOR:
      </Typography>
      <Divider style={{ marginBottom: "2vh" }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <AutocompleteMultipleComponent
                name="formCPR"
                control={control}
                label="CAMPOS DO FORMULÁRIO"
                withoutAcessor={true}
                options={formCPROptions}
                disabled={isLoading}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default CPRSectionComponent;
